import { Modal } from "semantic-ui-react";

import { LoginForm } from "modules/Login/components/LoginForm";
import "modules/Login/components/LoginModal/LoginModal.scss";
import { useIsSessionExpired } from "modules/Login/components/LoginModal/useIsSessionExpired";

import type { ModalProps } from "semantic-ui-react";

export const LoginModal = ({ onClose }: ModalProps) => {
  const isSessionExpired = useIsSessionExpired();

  return (
    <Modal size="tiny" open={isSessionExpired} onClose={onClose} className="LoginModal">
      <Modal.Content>
        <LoginForm isModalOpen={true} />
      </Modal.Content>
    </Modal>
  );
};
